import RestaurantReviews from './RestaurantReviews';

export default RestaurantReviews;
